exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._154Xa{padding-top:0;position:relative;z-index:1}._20If5{margin-bottom:20px}._1yREH{margin:0 auto}.l8--r{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}._1Ynl4{width:300px}._1Ynl4,._3ED_b{position:relative}._3ED_b{width:calc(100% - 300px);padding-right:20px}", ""]);

// exports
exports.locals = {
	"page": "_154Xa page",
	"Juan": "_20If5",
	"container": "_1yREH container",
	"flexRow": "l8--r flexRow",
	"w300": "_1Ynl4",
	"mainCell": "_3ED_b"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/routes/spareparts/spareparts-singlepage/SparepartsSinglePage.css
// module id = 3131
// module chunks = 36